import React, { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import { ElectionOverview } from 'components/electionOverview'
import ThemeSwitch from '@ta-interaktiv/react-theme-switch'
import { LocaleContext } from 'contexts/locale'
import { Locale } from 'types/Locale'

export function App() {
  const [locale, setLocale] = useState<Locale>('de')

  useEffect(() => {
    const location = new URL(window.location.href)
    const lc = location.searchParams.get('lc')
    if (lc) {
      setLocale(lc as Locale)
    }
  }, [window.location.href])

  ThemeSwitch({})
  return (
    <LocaleContext.Provider value={locale}>
      <ElectionOverview />
    </LocaleContext.Provider>
  )
}
